import useListTwoMutation from './useListTwoMutation';

export { useListTwoMutation };
